// extracted by extract-css-chunks-webpack-plugin
module.exports = {"progress":"app-components-player-progressbar-progressbar--progress"};